﻿
import * as l from "lenovo";
import * as React from "react";
import { Tile } from '../../../../core/src/common/tile/Tile';
import * as ReactDOM from "react-dom";

const TileBox = ({data}) => {
    let OptionClick = (typeKey, index) => {
        if (typeKey == "RichText") {
            var allItems = $('.tile-wrapper').length, num, lineItems;
            var bodyWidth = $(window).width() + 17,
                column = [{
                    minWidth: 1200,
                    items: 4
                }, {
                    minWidth: 992,
                    items: 3
                }, {
                    minWidth: 768,
                    items: 2
                }, {
                    minWidth: 0,
                    items: 1
                }];
            for (var i = 0; i < column.length; i++) {
                if (bodyWidth > column[i].minWidth) {
                    lineItems = column[i].items;
                    break;
                }
            }
            var itemIndex = index, currentLastItem;
            var cloneHtml = $("div[name=itemcontent_" + itemIndex + "]").clone(true, true);
            $("div[name=itemcontent_" + itemIndex + "]").remove();
            currentLastItem = (parseInt(itemIndex / lineItems) + 1) * lineItems - 1;
            if (currentLastItem < allItems) {
                num = currentLastItem;
            } else {
                num = allItems - 1;
            }
            $(cloneHtml).insertAfter($(".tile-wrapper").eq(num)).show();
            $('.close').off('click');
            $(".close").on("click", function (event) {
                $(event.currentTarget).parent("div").hide();
            });
            $('.tile-wrapper').each(function () {
                $('html, body').animate({
                    scrollTop: $(window).scrollTop() + 200
                }, 1000);
                return false;
            });
        }
    }
    let items = data.Tiles;
    if (!items || items.length < 1) return <div/>;
    let result = [];
    let yPostion: number = 1;
    items.forEach((value: any, index: number) => {
        if (value.ComponentContent) {
            sessionStorage.ComponentContent = value.ComponentContent;
        }
        value.IsContactUs = true;
        value.recommended = value.IsRecommended;
        value.isPremier = value.IsPremier;
        value.isPDtree = false;
        var xPostion = (index / 3) + 1;
        value.postion = `${xPostion.toString().indexOf('.') == -1 ? xPostion : xPostion.toString().split('.')[0]}*${yPostion}`;
        value.product = { Serial: data.Serial, WarrantyInfo: { warrantyStatus: data.warrantyStatus }, ProductBrand: data.ProductBrand};
        value.IsPSP =  false;
        result.push(<Tile props={ value } onClick= { OptionClick } />);
        if (yPostion >= 3) {
            yPostion = 0;
        }
        yPostion++;
    }, this)
    return (
        <div className="tileitembox">
            {result}
        </div>
    );
}



export const rendre =(elId,data)=>{
    ReactDOM.render(<TileBox data={data} />,document.getElementById(elId));
}